export const tooltipTheme = {
  colorScheme: {
    light: {
      root: {
        gutter: '0.25rem',
        padding: '0.25rem 0.5rem',
        borderRadius: '{border.radius.sm}',
        shadow: '0 2px 12px 0 rgba(0, 0, 0, 0.15)',
        background: '{gray.800}',
        color: '{gray.0}'
      }
    },
    dark: {
      root: {
        gutter: '0.25rem',
        padding: '0.25rem 0.5rem',
        borderRadius: '{border.radius.sm}',
        shadow: '0 2px 12px 0 rgba(0, 0, 0, 0.3)',
        background: '{gray.700}',
        color: '{gray.0}'
      }
    }
  }
};
